<template>
  <div
    :class="['banner', isCursorPointe]"
    :style="{ 'background-image': `url(${backgroundImage})` }"
  >
    <span class="banner__subtitle">{{ subtitle }}</span>
    <span class="banner__title"
      >{{ title }}
      <span v-if="extraTitle" class="extra-title">· {{ extraTitle }}</span>
    </span>
    <span class="banner__line" v-if="show"></span>
    <span class="banner__discription">{{ des }}</span>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    subtitle: {
      type: String,
      default: '浙江省金融综合服务平台',
    },
    title: {
      type: String,
      default: '浙里金融',
    },
    extraTitle: {
      type: String,
      default: '',
    },
    des: {
      type: String,
      default: '一键发布融资需求，智能匹配金融产品，银行快速响应对接',
    },
    backgroundImage: {
      type: String,
      default: require('../assets/images/home-banner1x.png'),
    },
    show: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    isCursorPointe() {
      let arr = ['浙里金融']
      if (this.$route.path !== '/') return ''
      return arr.includes(this.title) ? '' : 'banner-cursor'
    },
  },
}
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 400px;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;

  &__title {
    font-size: 32px;
    color: #fff;
    position: absolute;
    top: 157px;
    left: 52%;
    margin-left: -420px;
    letter-spacing: 2px;
    transform: translateX(-100px);
    font-weight: bold;

    .extra-title {
      font-size: 30px;
      font-weight: normal;
    }
  }

  &__subtitle {
    font-size: 20px;
    color: #fff;
    position: absolute;
    top: 120px;
    left: 52%;
    margin-left: -420px;
    letter-spacing: 1px;
    transform: translateX(-100px);
  }

  &__discription {
    font-size: 20px;
    color: #fff;
    position: absolute;
    top: 236px;
    left: 52%;
    margin-left: -419px;
    letter-spacing: 1px;
    transform: translateX(-100px);
  }

  &__line {
    position: absolute;
    top: 224px;
    left: 52%;
    margin-left: -419px;
    transform: translateX(-100px);

    &::before {
      content: '';
      display: block;
      position: relative;
      left: 0;
      top: 3px;
      width: 20px;
      height: 4px;
      background: #fff;
    }

    &::after {
      content: '';
      display: block;
      position: absolute;
      background: linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
      width: 396px;
      height: 2px;
      left: 20px;
      opacity: 0.5;
    }
  }
}

.banner-cursor {
  cursor: pointer;
}
</style>
